import React from 'react';
import NuevaReceta from './NuevaReceta';

/**
 * Wrapper para crear nuevas recetas
 */
function NuevaRecetaWrapper() {
  return <NuevaReceta />;
}

export default NuevaRecetaWrapper; 